import { z } from "zod/v4";
import { createEndpointBase } from "./core";
import { DocumentationSchemas } from "../ea.schema";
import { ReportExtension } from "../ea.enums";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { DocumentationFilterSchema, GetRequestBaseResponseSchema } from "../ea.schema.query";

const base = "documentations";
const docs = createEndpointBase(base);
const reports = createEndpointBase(base, "reports");

export const documentationsEndpoints = {
  documentationsGet: docs({
    method: "GET",
    path: "",
    request: z.object({ filter: DocumentationFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(DocumentationSchemas["general"]),
    description: "Retrieves a list of documentation records with filtering support.",
  }),
  documentationsCount: docs({
    method: "GET",
    path: "count",
    request: z
      .object({ filter: DocumentationFilterSchema.pick({ where: true }).optional() })
      .optional(),
    response: CountResponseSchema,
    description: "Returns the total number of documentation records matching the filters.",
  }),
  documentationsUpdate: docs({
    method: "PATCH",
    path: ":id",
    request: DocumentationSchemas["update"].extend({
      confirmationToken: z.string().optional(),
    }),
    response: DocumentationSchemas["general"],
    description: "Updates a documentation record.",
  }),
  documentationsDelete: docs({
    method: "DELETE",
    path: ":id",
    request: z.any(),
    response: z.any(),
    description: "Permanently deletes a documentation record.",
  }),
  documentationsDownloadFromScripts: docs({
    method: "POST",
    path: "download/scripts",
    request: z.object({ ids: z.array(z.coerce.number()) }),
    response: z.any(),
    description: "Downloads documentation for specified scripts.",
  }),
  documentationsDownload: docs({
    method: "POST",
    path: "download",
    request: z.object({ ids: z.array(z.coerce.number()) }),
    response: z.any(),
    description: "Downloads documentation files.",
  }),

  documentationsReportsDownload: reports({
    method: "POST",
    path: "download",
    request: z.object({ reportName: z.string() }),
    response: z.any(),
    description: "Downloads a generated documentation report.",
  }),
  documentationsReportsGenerate: reports({
    method: "POST",
    path: "generate",
    request: z.object({
      logId: z.coerce.number(),
      wsId: z.string(),
      extension: z.nativeEnum(ReportExtension),
      utcOffset: z.coerce.number(),
      reportName: z.string(),
    }),
    response: z.any(),
    description: "Generates a documentation report for a specific log.",
  }),
} as const;
